import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import { UIResponsivenessProvider } from "./components/UIResponsiveness";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <UIResponsivenessProvider>
        <App />
      </UIResponsivenessProvider>
    </BrowserRouter>
  </StrictMode>
);
